import {Switch as MantineSwitch, SwitchProps as MantineSwitchProps} from "@mantine/core";
import {forwardRef} from "react";

export type SwitchProps = MantineSwitchProps & {
  // extend props here
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
  const {...rest} = props;
  return <MantineSwitch ref={ref} {...rest} />;
});
